<template>
    <ion-toolbar>
        <ion-buttons slot="start"
            v-if="$store.state.pages.auth.back.length || routeName == 'profile_tax_payments_bank_details'">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" v-if="routeName !== 'profile_tax_payments_bank_details'">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Tax and Payments</h1>
                    <p class="auth-subtext">Please enter your bank account details</p>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-form class="full_page" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <div class="text-bank-details">Bank Details</div>
                <el-form-item class="no-scroll">
                    <el-input v-model="form.bank_name" autocomplete="off" placeholder="Name of Bank" @input="validateField('bank_name')" @change="validateField('bank_name')" @blur="validateField('bank_name')"/>
                    <el-form-item-error v-if="v$.bank_name.$error">{{ v$.bank_name.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item class="no-scroll">
                    <el-input :controls="false" v-model="form.routing_number" autocomplete="off" placeholder="Routing Number" @input="validateRoutingNumber" @keyup="validateRoutingNumber" @blur="validateField('routing_number')"/>
                    <el-form-item-error v-if="v$.routing_number.$error">{{ v$.routing_number.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item class="no-scroll">
                    <el-input :controls="false" v-model="form.account_number" autocomplete="off" placeholder="Account Number" @input="validateField('account_number')" @change="validateField('account_number')" @blur="validateField('account_number')"/>
                    <el-form-item-error v-if="v$.account_number.$error">{{ v$.account_number.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item class="no-scroll">
                    <el-input :controls="false" v-model="form.confirm_account_number" autocomplete="off" placeholder="Re-enter Account Number" @input="validateField('confirm_account_number')" @change="validateField('confirm_account_number')" @blur="validateField('confirm_account_number')"/>
                    <el-form-item-error v-if="v$.confirm_account_number.$error">{{ v$.confirm_account_number.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item class="no-scroll">
                    <el-input v-model="form.account_name" autocomplete="off" placeholder="Account in the name(s) of" @input="validateField('account_name')" @change="validateField('account_name')" @blur="validateField('account_name')"/>
                    <el-form-item-error v-if="v$.account_name.$error">{{ v$.account_name.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <!-- <el-form-item class="no-scroll">
                    <el-input v-model="form.social_security_number" autocomplete="off"
                        placeholder="Social Security Number" readonly />
                    <el-form-item-error v-if="v$.social_security_number.$error">{{
                        v$.social_security_number.$errors[0].$message }}</el-form-item-error>
                </el-form-item> -->
             
                <el-form-item class="button_submit mb0">
                    <el-button class="submit w-100" type="blue" @click="goNext('userForm')"
                        :disabled="isSubmitDisabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>

<script>
import {
    onMounted,
    inject,
    computed,
    reactive,
    // watch
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'

import {
    useRouter,
    useRoute
} from 'vue-router'

import { useVuelidate } from '@vuelidate/core';
import { required, helpers, sameAs } from '@vuelidate/validators';
import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const routeName = $route.name;
        const setPageClassGlobal = inject('setPageClassGlobal');
        const userData = $store.getters.GET_USER_DATA;

        const form = reactive({
            account_name: userData.billing.accountName || '',
            routing_number: parseInt(userData.billing.routingNumber) || '',
            account_number: parseInt(userData.billing.accountNumber) || '',
            confirm_account_number: parseInt(userData.billing.accountNumber) || '',
            // social_security_number: userData.settings.socialSecurityNumber || '',
            bank_name: userData.billing.bankName || '',
        });

        const rules = computed(() => {
            return {
                account_name: { required: helpers.withMessage('Please enter the account in the name(s) of', required) },
                routing_number: { 
                    required: helpers.withMessage('Please enter the routing number', required),
                    minLength: helpers.withMessage('Routing number must be 9 digits', (value) => value.toString().length == 9)
                 },
                account_number: { required: helpers.withMessage('Please enter the account number', required) },
                confirm_account_number: { 
                    required: helpers.withMessage('Please re-enter the account number', required),
                    sameAsAccountNumber: helpers.withMessage('Account numbers do not match', sameAs(form.account_number))
                },
                // social_security_number: { required: helpers.withMessage('Please enter the social security number', required) },
                bank_name: { required: helpers.withMessage('Please enter the name of bank', required) },
            };
        });

        const v$ = useVuelidate(rules, form);

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        const validateRoutingNumber = () => {
        // Use a regular expression to allow only digits and limit to 9 digits
        const regex = /^\d{0,9}$/; // Allow up to 9 digits

        if (!regex.test(form.routing_number)) {
            validateField('routing_number');
            form.routing_number = form.routing_number.replace(/\D/g, ''); // Remove any non-digit characters
            form.routing_number = form.routing_number.slice(0, 9);
        }
        
    };

//         watch(() => form.account_number, () => {
//     // Only trigger validation if the user has interacted with the account_number field
//     if (v$.value.account_number.$dirty) {
//         v$.value.confirm_account_number.$touch(); // Trigger validation for confirm_account_number
//     }
// });

        const goBack = async() => {
            if (routeName == "profile_tax_payments_bank_details") {
                $router.push({
                    name: "profile_edit"
                })
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            }

        };

        const isSubmitDisabled = computed(() => {
            return Object.values(form).some(value => value.length == 0) || v$.value.$pending || v$.value.$error || v$.value.$invalid;
        });

        const goNext = async () => {
            const result = await v$.value.$validate();
            form.onboarding_step = "tax_payments_bank_details";
            if (!result) {
                alert('The form has errors');
                return;
            }
            (async () => {
                try {
                    await $store.dispatch('SAVE_USER_DATA', form);
                    if (routeName == "profile_tax_payments_bank_details") {
                        $router.push({
                            name: "profile_edit"
                        })
                    } else {
                        $router.push({
                            name: 'auth_software_experience',
                        });
                    }


                } catch (error) {
                    console.error('Error submitting form:', error);
                }
            })();
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_software_experience',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();

        }

        onMounted(() => {
            setPageClassGlobal('global_auth_tax_payments_bank_details_page');
        });

        return {
            form,
            goBack,
            goNext,
            isSubmitDisabled,
            v$,
            validateField,
            skip,
            routeName,
            validateRoutingNumber
        }
    },
}
</script>